// Core guide logic as a regular class
class CustomGuideCore {
  static CACHE = new Map();
  static CACHE_LIMIT = 10;

  constructor() {
    this.popup = document.querySelector("custom-guide");
    this.loader = this.popup?.querySelector("custom-guide-loader");
    this.close = this.popup?.querySelector("[data-js-close]");
    this.content = this.popup?.querySelector("custom-guide-content");
    this.wrapper = this.popup?.querySelector("custom-guide-wrapper");

    if (this.popup && this.close) {
      this.popup.addEventListener("click", (e) => {
        if (e.target === this.popup && e.target.classList.contains("active"))
          this.hide();
      });
      this.close.addEventListener("click", () => this.hide());
    }
  }

  open(url, sectionId = "helper-page-content") {
    this.sectionId = sectionId;
    this.url = url + "?section_id=" + sectionId;
    this.show();
  }

  cacheContent(u, c) {
    CustomGuideCore.CACHE.set(u, c);
    if (CustomGuideCore.CACHE.size > CustomGuideCore.CACHE_LIMIT)
      CustomGuideCore.CACHE.delete(CustomGuideCore.CACHE.keys().next().value);
  }

  getCachedContent(u) {
    return CustomGuideCore.CACHE.get(u) || null;
  }

  show() {
    this.popup.classList.remove("closing");
    this.popup.classList.add("active");
    document.body.classList.add("modal-open");
    [this.popup, this.loader].forEach((el) => el.classList.add("working"));
    this.fetchContent(this.url);
  }

  hide() {
    this.popup.classList.remove("active");
    this.popup.classList.add("closing");
    this.popup.classList.remove("loaded");
    this.wrapper?.classList.remove("sidebar--opened");
    document.body.classList.remove("modal-open");

    setTimeout(() => {
      this.popup.classList.remove("closing", "working");
    }, 300);
  }

  async fetchContent(u) {
    let txt = this.getCachedContent(u);
    if (txt) {
      this.renderContent(txt);
      return this._done();
    }
    try {
      const res = await fetch(u);
      txt = await res.text();
      this.cacheContent(u, txt);
      this.renderContent(txt);
    } catch (e) {
      console.error("Error fetching content:", e);
    }
    this._done();
  }

  renderContent(t) {
    this.content.innerHTML = t;
  }

  setTitle() {
    const title = this.content.querySelector("[data-guide-title]");
    if (title) {
      this.popup.querySelector(".sidebar__header .sidebar__title").textContent =
        title.textContent;
    }
  }

  _done() {
    [this.popup, this.loader].forEach((el) => el.classList.remove("working"));
    this.sectionId = null;
    requestAnimationFrame(() => {
      this.popup.classList.add("loaded");
      requestAnimationFrame(() => {
        this.wrapper?.classList.add("sidebar--opened");
      });
    });
    this.content
      .querySelectorAll(".rte a img")
      .forEach((i) => (i.parentNode.style.border = "none"));
    this.content
      .querySelectorAll(".rte table")
      .forEach(
        (t) => (t.outerHTML = `<div class="table-wrapper">${t.outerHTML}</div>`)
      );

    // Initialize table hover functionality for newly loaded content
    if (this.content.querySelector("table")) {
      this.initializeTableHovers();
    }
    // Initialize unit conversion for tables
    // this.initializeUnitConversion();

    // Set the title of the popup
    this.setTitle();
  }

  initializeTableHovers() {
    const tables = this.content.querySelectorAll("table");

    tables.forEach((table) => {
      const cells = table.querySelectorAll("td");

      cells.forEach((cell) => {
        cell.addEventListener("mouseenter", function () {
          // Remove any existing hover classes from this table
          cells.forEach((c) => {
            c.classList.remove("hover-row", "hover-col", "hover-cell");
          });

          // Get current cell position
          const row = this.parentElement;
          const rowIndex = Array.from(row.parentElement.children).indexOf(row);
          const cellIndex = Array.from(row.children).indexOf(this);

          // Highlight current row
          row.querySelectorAll("td").forEach((td) => {
            td.classList.add("hover-row");
          });

          // Highlight current column
          table
            .querySelectorAll(`tr td:nth-child(${cellIndex + 1})`)
            .forEach((td) => {
              td.classList.add("hover-col");
            });

          // Highlight current cell with stronger color
          this.classList.add("hover-cell");
        });

        cell.addEventListener("mouseleave", function () {
          cells.forEach((c) => {
            c.classList.remove("hover-row", "hover-col", "hover-cell");
          });
        });
      });
    });
  }
}

// HTML element wrapper that uses CustomGuideCore
if (!customElements.get("jack-custom-guide")) {
  class JackCustomGuide extends HTMLElement {
    constructor() {
      super();
      this.core = new CustomGuideCore();
      this.addEventListener("click", (e) => {
        e.preventDefault();
        const sectionId = this.dataset.sectionId || "helper-page-content";
        const url = this.dataset.url;
        this.core.open(url, sectionId);
      });
    }
  }

  customElements.define("jack-custom-guide", JackCustomGuide);
}

// Initialize CustomGuideCore when popup is available
if (document.querySelector("custom-guide")) {
  window.CustomGuideOpener = new CustomGuideCore();
  window.dispatchEvent(new Event("customGuideReady"));
} else {
  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector("custom-guide")) {
      window.CustomGuideOpener = new CustomGuideCore();
      window.dispatchEvent(new Event("customGuideReady"));
    }
  });
}
